var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReceipt = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "receipt",
    width: 28.532,
    height: 30.436,
    viewBox: "0 0 28.532 30.436",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M39.789,0H19.816l.08.038a4.238,4.238,0,0,0-3.884,4.215v7.16h7.609V29.484a.951.951,0,0,0,1.3.883l4.4-1.761,4.4,1.761a.925.925,0,0,0,.706,0l4.4-1.761,4.4,1.761a.959.959,0,0,0,.354.068.952.952,0,0,0,.951-.951V4.755A4.761,4.761,0,0,0,39.789,0ZM23.621,5.706v3.8H17.914V4.253A2.355,2.355,0,0,1,20.265,1.9h1a2.355,2.355,0,0,1,2.351,2.351ZM39.789,22.826H32.18a.951.951,0,0,1,0-1.9h7.609a.951.951,0,0,1,0,1.9Zm0-3.8H32.18a.951.951,0,0,1,0-1.9h7.609a.951.951,0,0,1,0,1.9Zm0-3.8H28.376a.951.951,0,0,1,0-1.9H39.789a.951.951,0,0,1,0,1.9Zm0-7.609H28.376a.951.951,0,0,1,0-1.9H39.789a.951.951,0,0,1,0,1.9Z",
    transform: "translate(-16.012)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReceipt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/receipt.c7f9f532.svg";
export { ForwardRef as ReactComponent };